import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Reducers
import {
  BannerReducers,
  ProductReducers,
  CartReducers,
  UserReducers,
  AddressReducers,
  CheckoutReducers,
  BrandReducers,
  CategoryReducers,
  FavouriteReducers
} from './reducers'

// Combine Reducers
const rootReducer = combineReducers({
  products: ProductReducers,
  cart: CartReducers,
  user: UserReducers,
  userAddress: AddressReducers,
  checkout: CheckoutReducers,
  banners: BannerReducers,
  brands: BrandReducers,
  categories: CategoryReducers,
  favourites: FavouriteReducers,
});

// Persist Configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ['user', 'cart', 'userAddress', 'favourites'], // Only persist specific reducers
};

// Create Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for async storage
      immutableCheck: false,
    }),
  devTools: true, // Enable Redux DevTools for debugging
});

// Create Persistor
const persistor = persistStore(store);

export { store, persistor };
